export default __webpack_public_path__ + "static/media/lechuga.7e502453.png";